import React, { useState, useEffect } from "react";
import axios from "axios";
import { useOutletContext, Link } from "react-router-dom";
import { MaterialReactTable } from "material-react-table";
import AddSearchProposal from "../../components/Modals/searchproposal/AddSearchProposal";
import useSmartBack from "../../hooks/useSmartBack";

function Searchproposal() {
  const [data, setData] = useState([]);
  const [isAddModalOpen, setIsAddModalOpen] = useState(false); // State for Add Job Modal
  const [isEditModalOpen, setIsEditModalOpen] = useState(false); // State for Edit Job Modal
  const [selectedRow, setSelectedRow] = useState(null);
  const [jobId, setJobId] = useState(null); // State for the selected job ID
  const { setGlobalLoading, token } = useOutletContext();
  const handleBack = useSmartBack("/role/list");
  const API = process.env.REACT_APP_API_BASE_URL;

  
    const fetchData = async () => {
      try {
        setGlobalLoading(true);
        const res = await axios.get(`${API}/roles/searchproposallist/`, {
          headers: { Authorization: `Bearer ${token}` },
        });
        if (res.data.lists.length > 0) {
          setData(res.data.lists);
        }
        // setData(res.data.lists || []);
      } catch (err) {
        console.error("Fetch failed", err);
      } finally {
        setGlobalLoading(false);
      }
    }

   useEffect(() => {
  fetchData();
}, []);

  const handleAddNew = () => {
    setSelectedRow(null); // Clear for new form
    setIsAddModalOpen(true); // Open Add Modal
  };

  const columns = [
    { accessorKey: "role_id", header: "Role ID", size: 50 },
   {
    accessorKey: "name",
    header: "Name",
    Cell: ({ row }) => (
    <div className="ms-2">
      <h6 className="fw-medium mb-0">
        <Link
          to={`/role/view/${row.original.id}`}
          className="text-primary"
        >
          {row.original.name}
        </Link>
      </h6>
    </div>
  ),
  },
    {
      accessorKey: "company_info",
      header: "Company",
      Cell: ({ row }) => {
        const companyData = row.original.company_info || "";
        const [name, logo] = companyData.split("|||");

        return (
          <div style={{ display: "flex", alignItems: "center", gap: "8px" }}>
            {logo && (
              <img
                src={`https://pinepositivemoves.com/files/companyLogo/${logo}`}
                alt={name}
                style={{
                  width: "28px",
                  height: "28px",
                  borderRadius: "4px",
                  objectFit: "contain",
                  border: "1px solid #ccc",
                  backgroundColor: "#fff",
                }}
              />
            )}
            <span>{name}</span>
          </div>
        );
      },
    },

    { accessorKey: "role_manager", header: "Client Manager" },
    { accessorKey: "created_by", header: "Assigned to" },
    {
      accessorKey: "assigned_worker_pictures",
      header: "Resource",
      size: 80,
      Cell: ({ row }) => {
        const picsString = row.original.assigned_worker_pictures;
        const pictureFilenames = picsString ? picsString.split(";;;") : [];
        if (pictureFilenames.length === 0) {
          return null; // blank — no image shown
        }

        return (
          <div style={{ display: "flex", gap: "5px", flexWrap: "wrap" }}>
            {pictureFilenames.length > 0 ? (
              pictureFilenames.map((pic, index) => (
                <img
                  key={index}
                  src={`https://pinepositivemoves.com/files/media/${pic}`}
                  alt={`Profile ${index}`}
                  style={{
                    width: "32px",
                    height: "32px",
                    borderRadius: "50%",
                    objectFit: "cover",
                    border: "1px solid #ddd", // subtle border for better look
                  }}
                  onError={(e) => {
                    e.target.onerror = null;
                    e.target.src = "/default-profile.png";
                  }}
                />
              ))
            ) : (
              <img
                src="https://smarthr.dreamstechnologies.com/html/template/assets/img/users/user-39.jpg"
                alt="Default"
                style={{
                  width: "35px",
                  height: "35px",
                  borderRadius: "50%",
                  objectFit: "cover",
                }}
              />
            )}
          </div>
        );
      },
    },

    // { accessorKey: "industrymaster", header: "Major Industry" },
    // { accessorKey: "industry", header: "Industry" },
    { accessorKey: "function", header: "Function" },
    // { accessorKey: "assigned_to", header: "Source" },
    { accessorKey: "days_since_proposal", header: "TAT" },

    // {
    //   header: "Action",
    //   id: "action",
    //   Cell: ({ row }) => (
    //     <button
    //       className="btn btn-sm btn-outline-primary"
    //       onClick={() => {
    //         setSelectedRow(row.original); // Set selected row to be edited
    //         setJobId(row.original.job_id); // Set the job_id
    //         setIsEditModalOpen(true); // Open Edit Modal
    //       }}
    //     >
    //       Edit
    //     </button>
    //   ),
    // },
  ];

  return (
    <div className="content">
      <div className="card">
        <div className="card-header d-flex align-items-center flex-wrap gap-2">
          <h5 className="mb-0">Roles</h5>
          <button
            className="btn btn-outline-secondary btn-sm d-inline-flex align-items-center"
            style={{ marginLeft: "auto", cursor: "pointer" }}
            onClick={handleBack}
          >
            <i className="ti ti-arrow-left me-2"></i>
            Back
          </button>
        </div>

        <div className="card-body">
            <MaterialReactTable
              columns={columns}
              data={data}
              enableFilters
              enableColumnOrdering
              muiTableBodyCellProps={{ sx: { padding: "8px 10px" } }}
              muiTableHeadCellProps={{
                sx: { backgroundColor: "#f5f5f5", fontWeight: "bold" },
              }}
              renderTopToolbarCustomActions={() => (
                <div className="d-flex gap-2 align-items-center ms-2 flex-wrap">
                  <button
                    className="btn btn-primary btn-sm"
                    onClick={handleAddNew}
                  >
                    New search proposal
                  </button>
                  {/* <button
                    className="btn btn-outline-secondary btn-sm"
                    onClick={goToClosedJobs}
                  >
                    Jobs added to pre users
                  </button>
                  <button
                    className="btn btn-outline-secondary btn-sm"
                    onClick={goToShelvedJobs}
                  >
                    Shelved Jobs
                  </button>
                  <button
                    className="btn btn-outline-secondary btn-sm"
                    onClick={goToRegisteredUsers}
                  >
                    Registered Users
                  </button> */}
                </div>
              )}
            />
        </div>
      </div>

      {/* Modal for Add Job */}
      {isAddModalOpen && (
        <AddSearchProposal
          show={isAddModalOpen}
          onClose={() => setIsAddModalOpen(false)}
          defaultValues={selectedRow}
          onSuccess={fetchData}
        />
      )}
    </div>
  );
}

export default Searchproposal;
